/* tslint:disable */
/* auto-generated angular directive proxies */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, NgZone } from '@angular/core';
import { ProxyCmp, proxyOutputs } from './angular-component-lib/utils';

import { Components, GritEventData } from '@progleasing/grit-universal';



import type { GritEventData as IGritAccordionGritEventData } from '@progleasing/grit-universal';
import type { GritAccordionEventData as IGritAccordionGritAccordionEventData } from '@progleasing/grit-universal';
export declare interface GritWcAccordion extends Components.GritWcAccordion {
  /**
   * Event fires when the accordion changes state, returning an object with
a boolean value depending of if it is opened or closed (true/false) 
   */
  gritUpdate: EventEmitter<CustomEvent<GritEventData<IGritAccordionGritAccordionEventData>>>;

}

@ProxyCmp({
  tagName: 'grit-wc-accordion',
  customElement: undefined,
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'isOpen', 'pii'],
  methods: ['open', 'close']
})
@Component({
  selector: 'grit-wc-accordion',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'isOpen', 'pii']
})
export class GritWcAccordion {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['gritUpdate']);
  }
}


export declare interface GritWcAnalytics extends Components.GritWcAnalytics {}

@ProxyCmp({
  tagName: 'grit-wc-analytics',
  customElement: undefined
})
@Component({
  selector: 'grit-wc-analytics',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>'
})
export class GritWcAnalytics {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}

import type { GritEventData as IGritAutocompleteGritEventData } from '@progleasing/grit-universal';
export declare interface GritWcAutocomplete extends Components.GritWcAutocomplete {
  /**
   * Update event fired whenever the input of the
autocomplete changes. 
   */
  gritUpdate: EventEmitter<CustomEvent<GritEventData<string>>>;

}

@ProxyCmp({
  tagName: 'grit-wc-autocomplete',
  customElement: undefined,
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'disabled', 'display', 'errorKey', 'label', 'matchFullCase', 'name', 'pii', 'useValidationIcon', 'value'],
  methods: ['open', 'close']
})
@Component({
  selector: 'grit-wc-autocomplete',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'disabled', 'display', 'errorKey', 'label', 'matchFullCase', 'name', 'pii', 'useValidationIcon', 'value']
})
export class GritWcAutocomplete {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['gritUpdate']);
  }
}

import type { GritAutocompleteItemData as IGritAutocompleteItemGritAutocompleteItemData } from '@progleasing/grit-universal';
export declare interface GritWcAutocompleteItem extends Components.GritWcAutocompleteItem {
  /**
   * Event fired when an item is selected with the selected value. 
   */
  itemSelected: EventEmitter<CustomEvent<IGritAutocompleteItemGritAutocompleteItemData>>;

}

@ProxyCmp({
  tagName: 'grit-wc-autocomplete-item',
  customElement: undefined,
  inputs: ['displayValue', 'filteredValue', 'value']
})
@Component({
  selector: 'grit-wc-autocomplete-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['displayValue', 'filteredValue', 'value']
})
export class GritWcAutocompleteItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['itemSelected']);
  }
}


export declare interface GritWcAutocompleteMessage extends Components.GritWcAutocompleteMessage {}

@ProxyCmp({
  tagName: 'grit-wc-autocomplete-message',
  customElement: undefined,
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'errorKey', 'showMoreText', 'visible']
})
@Component({
  selector: 'grit-wc-autocomplete-message',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'errorKey', 'showMoreText', 'visible']
})
export class GritWcAutocompleteMessage {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface GritWcBadge extends Components.GritWcBadge {}

@ProxyCmp({
  tagName: 'grit-wc-badge',
  customElement: undefined,
  inputs: ['progress', 'showIcon', 'type']
})
@Component({
  selector: 'grit-wc-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['progress', 'showIcon', 'type']
})
export class GritWcBadge {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface GritWcButton extends Components.GritWcButton {
  /**
   * Click event fired whenever a button is clicked.
The events returns the event itself, and it case the button
is of type submit, dispatches a submitEvent to the closest
form. 
   */
  gritClick: EventEmitter<CustomEvent<any>>;
  /**
   * Grit Blur fires on blur of the button 
   */
  gritBlur: EventEmitter<CustomEvent<any>>;
  /**
   * Grit Focus fires on focus of the button 
   */
  gritFocus: EventEmitter<CustomEvent<any>>;

}

@ProxyCmp({
  tagName: 'grit-wc-button',
  customElement: undefined,
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'color', 'disabled', 'download', 'form', 'fullWidth', 'href', 'loading', 'pii', 'rel', 'size', 'target', 'type']
})
@Component({
  selector: 'grit-wc-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'color', 'disabled', 'download', 'form', 'fullWidth', 'href', 'loading', 'pii', 'rel', 'size', 'target', 'type']
})
export class GritWcButton {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['gritClick', 'gritBlur', 'gritFocus']);
  }
}


export declare interface GritWcCalendar extends Components.GritWcCalendar {
  /**
   * Event emitted when the backdrop is clicked
in case the calendar is open. 
   */
  backdropClicked: EventEmitter<CustomEvent<any>>;
  /**
   * Update is emitted whenever a new date
is selected in the open calendar. And
it returns an event with the selected date. 
   */
  gritUpdate: EventEmitter<CustomEvent<Date>>;

}

@ProxyCmp({
  tagName: 'grit-wc-calendar',
  customElement: undefined,
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'format', 'label', 'maxDate', 'minDate', 'name', 'openMonth', 'options', 'parentSelector', 'value', 'visible'],
  methods: ['hide', 'show', 'setValue']
})
@Component({
  selector: 'grit-wc-calendar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'format', 'label', 'maxDate', 'minDate', 'name', 'openMonth', 'options', 'parentSelector', 'value', 'visible']
})
export class GritWcCalendar {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['backdropClicked', 'gritUpdate']);
  }
}


export declare interface GritWcCalendarActions extends Components.GritWcCalendarActions {
  /**
   * Event fired with the new date when a user interacts with one of the actions.
1) Change the month in the drop down.
2) Change the year in the drop down.
3) Click on one of the arrows. 
   */
  displayDateChange: EventEmitter<CustomEvent<Date>>;

}

@ProxyCmp({
  tagName: 'grit-wc-calendar-actions',
  customElement: undefined,
  inputs: ['analyticsEnabled', 'displayDate', 'months', 'selectableMonths', 'selectableYears', 'years']
})
@Component({
  selector: 'grit-wc-calendar-actions',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['analyticsEnabled', 'displayDate', 'months', 'selectableMonths', 'selectableYears', 'years']
})
export class GritWcCalendarActions {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['displayDateChange']);
  }
}


export declare interface GritWcCalendarBoard extends Components.GritWcCalendarBoard {
  /**
   * Event fired when a date is selected returning the
selected date as a string. 
   */
  daySelected: EventEmitter<CustomEvent<string>>;

}

@ProxyCmp({
  tagName: 'grit-wc-calendar-board',
  customElement: undefined,
  inputs: ['maxDate', 'minDate', 'month', 'selectedValue', 'year']
})
@Component({
  selector: 'grit-wc-calendar-board',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['maxDate', 'minDate', 'month', 'selectedValue', 'year']
})
export class GritWcCalendarBoard {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['daySelected']);
  }
}


export declare interface GritWcCalendarField extends Components.GritWcCalendarField {}

@ProxyCmp({
  tagName: 'grit-wc-calendar-field',
  customElement: undefined
})
@Component({
  selector: 'grit-wc-calendar-field',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>'
})
export class GritWcCalendarField {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface GritWcCard extends Components.GritWcCard {}

@ProxyCmp({
  tagName: 'grit-wc-card',
  customElement: undefined,
  inputs: ['elevation', 'padding']
})
@Component({
  selector: 'grit-wc-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['elevation', 'padding']
})
export class GritWcCard {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}

import type { GritEventData as IGritCheckboxGritEventData } from '@progleasing/grit-universal';
import type { GritCheckboxEventData as IGritCheckboxGritCheckboxEventData } from '@progleasing/grit-universal';
export declare interface GritWcCheckbox extends Components.GritWcCheckbox {
  /**
   * Event fired when the checkbox changes state, returning an object with
the value of the checkbox (true/false) 
   */
  gritUpdate: EventEmitter<CustomEvent<GritEventData<IGritCheckboxGritCheckboxEventData>>>;

}

@ProxyCmp({
  tagName: 'grit-wc-checkbox',
  customElement: undefined,
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'checked', 'disabled', 'elementId', 'error', 'indeterminate', 'labelAlignment', 'name', 'pii']
})
@Component({
  selector: 'grit-wc-checkbox',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'checked', 'disabled', 'elementId', 'error', 'indeterminate', 'labelAlignment', 'name', 'pii']
})
export class GritWcCheckbox {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['gritUpdate']);
  }
}

import type { GritEventData as IGritCheckboxGroupGritEventData } from '@progleasing/grit-universal';
import type { GritCheckboxGroupEventData as IGritCheckboxGroupGritCheckboxGroupEventData } from '@progleasing/grit-universal';
export declare interface GritWcCheckboxGroup extends Components.GritWcCheckboxGroup {
  /**
   *  
   */
  gritUpdateCheckBoxGroup: EventEmitter<CustomEvent<GritEventData<IGritCheckboxGroupGritCheckboxGroupEventData>>>;

}

@ProxyCmp({
  tagName: 'grit-wc-checkbox-group',
  customElement: undefined,
  inputs: ['direction', 'indeterminateElement', 'label', 'labelAlignment', 'options']
})
@Component({
  selector: 'grit-wc-checkbox-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['direction', 'indeterminateElement', 'label', 'labelAlignment', 'options']
})
export class GritWcCheckboxGroup {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['gritUpdateCheckBoxGroup']);
  }
}

import type { GritEventData as IGritChipGritEventData } from '@progleasing/grit-universal';
import type { GritChipEventData as IGritChipGritChipEventData } from '@progleasing/grit-universal';
export declare interface GritWcChip extends Components.GritWcChip {
  /**
   * Event to subscribe to when the action Icon is clicked
If the actionIcon prop is falsy, this will never emit 
   */
  actionIconClick: EventEmitter<CustomEvent<GritEventData<IGritChipGritChipEventData>>>;

}

@ProxyCmp({
  tagName: 'grit-wc-chip',
  customElement: undefined,
  inputs: ['actionIcon', 'analyticsCustomObj', 'analyticsEnabled', 'color', 'multiline', 'pii', 'textLang']
})
@Component({
  selector: 'grit-wc-chip',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['actionIcon', 'analyticsCustomObj', 'analyticsEnabled', 'color', 'multiline', 'pii', 'textLang']
})
export class GritWcChip {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['actionIconClick']);
  }
}


export declare interface GritWcClipboardCard extends Components.GritWcClipboardCard {}

@ProxyCmp({
  tagName: 'grit-wc-clipboard-card',
  customElement: undefined
})
@Component({
  selector: 'grit-wc-clipboard-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>'
})
export class GritWcClipboardCard {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface GritWcField extends Components.GritWcField {
  /**
   *  
   */
  gritErrorMessageUpdate: EventEmitter<CustomEvent<any>>;

}

@ProxyCmp({
  tagName: 'grit-wc-field',
  customElement: undefined,
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'errorKey', 'fireTriggerOption', 'hintOption', 'pii', 'useValidationIcons'],
  methods: ['triggerRender', 'setTouched', 'updateIcons', 'updateMessages']
})
@Component({
  selector: 'grit-wc-field',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'errorKey', 'fireTriggerOption', 'hintOption', 'pii', 'useValidationIcons']
})
export class GritWcField {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['gritErrorMessageUpdate']);
  }
}


export declare interface GritWcFieldIcon extends Components.GritWcFieldIcon {}

@ProxyCmp({
  tagName: 'grit-wc-field-icon',
  customElement: undefined,
  inputs: ['color', 'visible']
})
@Component({
  selector: 'grit-wc-field-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['color', 'visible']
})
export class GritWcFieldIcon {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface GritWcFieldMessage extends Components.GritWcFieldMessage {
  /**
   *  
   */
  moreIconClicked: EventEmitter<CustomEvent<any>>;

}

@ProxyCmp({
  tagName: 'grit-wc-field-message',
  customElement: undefined,
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'errorKey', 'isVisible', 'showMoreLabel', 'showMoreText']
})
@Component({
  selector: 'grit-wc-field-message',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'errorKey', 'isVisible', 'showMoreLabel', 'showMoreText']
})
export class GritWcFieldMessage {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['moreIconClicked']);
  }
}


export declare interface GritWcIcon extends Components.GritWcIcon {}

@ProxyCmp({
  tagName: 'grit-wc-icon',
  customElement: undefined,
  inputs: ['color', 'font', 'hidden', 'mode', 'size']
})
@Component({
  selector: 'grit-wc-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['color', 'font', 'hidden', 'mode', 'size']
})
export class GritWcIcon {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface GritWcIconButton extends Components.GritWcIconButton {
  /**
   * Click event fired whenever a button is clicked. 
   */
  gritClick: EventEmitter<CustomEvent<any>>;

}

@ProxyCmp({
  tagName: 'grit-wc-icon-button',
  customElement: undefined,
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'disabled', 'href', 'label', 'pii', 'primary', 'secondary', 'size']
})
@Component({
  selector: 'grit-wc-icon-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'disabled', 'href', 'label', 'pii', 'primary', 'secondary', 'size']
})
export class GritWcIconButton {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['gritClick']);
  }
}


export declare interface GritWcInPageNavigation extends Components.GritWcInPageNavigation {}

@ProxyCmp({
  tagName: 'grit-wc-in-page-navigation',
  customElement: undefined,
  inputs: ['currentPageUrl', 'pageLinks']
})
@Component({
  selector: 'grit-wc-in-page-navigation',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['currentPageUrl', 'pageLinks']
})
export class GritWcInPageNavigation {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}

import type { GritEventData as IGritLinearLoaderGritEventData } from '@progleasing/grit-universal';
export declare interface GritWcLinearLoader extends Components.GritWcLinearLoader {
  /**
   * Will emit an event update with the current progress value 
   */
  update: EventEmitter<CustomEvent<GritEventData<string>>>;

}

@ProxyCmp({
  tagName: 'grit-wc-linear-loader',
  customElement: undefined,
  inputs: ['display', 'loaderMessageProp', 'mode', 'progress', 'repeat'],
  methods: ['finish', 'initialize']
})
@Component({
  selector: 'grit-wc-linear-loader',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['display', 'loaderMessageProp', 'mode', 'progress', 'repeat']
})
export class GritWcLinearLoader {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['update']);
  }
}


export declare interface GritWcListSelect extends Components.GritWcListSelect {
  /**
   * Event fired whenever a new list item is selected with
the value of the list item. 
   */
  changeItem: EventEmitter<CustomEvent<string>>;

}

@ProxyCmp({
  tagName: 'grit-wc-list-select',
  customElement: undefined,
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'name', 'pii', 'selectedValue']
})
@Component({
  selector: 'grit-wc-list-select',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'name', 'pii', 'selectedValue']
})
export class GritWcListSelect {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['changeItem']);
  }
}


export declare interface GritWcListSelectItem extends Components.GritWcListSelectItem {
  /**
   * Event fires whenever an item is selected, with the value of it. 
   */
  gritUpdate: EventEmitter<CustomEvent<string>>;

}

@ProxyCmp({
  tagName: 'grit-wc-list-select-item',
  customElement: undefined,
  inputs: ['selected', 'value']
})
@Component({
  selector: 'grit-wc-list-select-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['selected', 'value']
})
export class GritWcListSelectItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['gritUpdate']);
  }
}


export declare interface GritWcLoaderMessage extends Components.GritWcLoaderMessage {}

@ProxyCmp({
  tagName: 'grit-wc-loader-message',
  customElement: undefined,
  inputs: ['delay', 'duration', 'height']
})
@Component({
  selector: 'grit-wc-loader-message',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['delay', 'duration', 'height']
})
export class GritWcLoaderMessage {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface GritWcMessage extends Components.GritWcMessage {}

@ProxyCmp({
  tagName: 'grit-wc-message',
  customElement: undefined,
  inputs: ['errorKey', 'visible']
})
@Component({
  selector: 'grit-wc-message',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['errorKey', 'visible']
})
export class GritWcMessage {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface GritWcMessageGroup extends Components.GritWcMessageGroup {}

@ProxyCmp({
  tagName: 'grit-wc-message-group',
  customElement: undefined,
  inputs: ['message', 'status']
})
@Component({
  selector: 'grit-wc-message-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['message', 'status']
})
export class GritWcMessageGroup {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface GritWcMoireCard extends Components.GritWcMoireCard {
  /**
   * Event emitted when the moire card with a link is clicked 
   */
  gritClick: EventEmitter<CustomEvent<any>>;

}

@ProxyCmp({
  tagName: 'grit-wc-moire-card',
  customElement: undefined,
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'href', 'pii', 'target']
})
@Component({
  selector: 'grit-wc-moire-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'href', 'pii', 'target']
})
export class GritWcMoireCard {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['gritClick']);
  }
}


export declare interface GritWcNotification extends Components.GritWcNotification {
  /**
   *  
   */
  dismissClick: EventEmitter<CustomEvent<any>>;
  /**
   *  
   */
  flagHide: EventEmitter<CustomEvent<any>>;

}

@ProxyCmp({
  tagName: 'grit-wc-notification',
  customElement: undefined,
  inputs: ['action', 'analyticsCustomObj', 'analyticsEnabled', 'closeActions', 'collapsed', 'color', 'disableAutoDismiss', 'display', 'elevation', 'enterSide', 'gestures', 'modifier', 'pii', 'timeout', 'type'],
  methods: ['show', 'hide', 'renderNotification']
})
@Component({
  selector: 'grit-wc-notification',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['action', 'analyticsCustomObj', 'analyticsEnabled', 'closeActions', 'collapsed', 'color', 'disableAutoDismiss', 'display', 'elevation', 'enterSide', 'gestures', 'modifier', 'pii', 'timeout', 'type']
})
export class GritWcNotification {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['dismissClick', 'flagHide']);
  }
}


export declare interface GritWcNotificationAction extends Components.GritWcNotificationAction {}

@ProxyCmp({
  tagName: 'grit-wc-notification-action',
  customElement: undefined,
  inputs: ['analyticsCustomObj', 'analyticsEnabled']
})
@Component({
  selector: 'grit-wc-notification-action',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['analyticsCustomObj', 'analyticsEnabled']
})
export class GritWcNotificationAction {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface GritWcNotificationFlag extends Components.GritWcNotificationFlag {
  /**
   *  
   */
  flagHide: EventEmitter<CustomEvent<any>>;
  /**
   *  
   */
  dismissClick: EventEmitter<CustomEvent<any>>;

}

@ProxyCmp({
  tagName: 'grit-wc-notification-flag',
  customElement: undefined,
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'childrenRender', 'color', 'disableAutoDismiss', 'display', 'enterSide', 'gestures', 'modifier', 'pii', 'timeout'],
  methods: ['show', 'hide']
})
@Component({
  selector: 'grit-wc-notification-flag',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'childrenRender', 'color', 'disableAutoDismiss', 'display', 'enterSide', 'gestures', 'modifier', 'pii', 'timeout']
})
export class GritWcNotificationFlag {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['flagHide', 'dismissClick']);
  }
}

import type { GritEventData as IGritOptionSelectGritEventData } from '@progleasing/grit-universal';
export declare interface GritWcOptionSelect extends Components.GritWcOptionSelect {
  /**
   *  
   */
  gritUpdate: EventEmitter<CustomEvent<GritEventData<String | String[]>>>;

}

@ProxyCmp({
  tagName: 'grit-wc-option-select',
  customElement: undefined,
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'direction', 'disabled', 'error', 'name', 'showMoreText', 'type', 'value']
})
@Component({
  selector: 'grit-wc-option-select',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'direction', 'disabled', 'error', 'name', 'showMoreText', 'type', 'value']
})
export class GritWcOptionSelect {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['gritUpdate']);
  }
}

import type { GritEventData as IGritOptionSelectElementGritEventData } from '@progleasing/grit-universal';
import type { GritRadioEventData as IGritOptionSelectElementGritRadioEventData } from '@progleasing/grit-universal';
export declare interface GritWcOptionSelectElement extends Components.GritWcOptionSelectElement {
  /**
   *  
   */
  optionSelectUpdate: EventEmitter<CustomEvent<GritEventData<IGritOptionSelectElementGritRadioEventData>>>;

}

@ProxyCmp({
  tagName: 'grit-wc-option-select-element',
  customElement: undefined,
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'checked', 'direction', 'disabled', 'name', 'pii', 'type', 'value']
})
@Component({
  selector: 'grit-wc-option-select-element',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'checked', 'direction', 'disabled', 'name', 'pii', 'type', 'value']
})
export class GritWcOptionSelectElement {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['optionSelectUpdate']);
  }
}


export declare interface GritWcOverlayContainer extends Components.GritWcOverlayContainer {
  /**
   * Fires immediately after showOverlay property changes if the modal isn't being displayed. 
   */
  willOpen: EventEmitter<CustomEvent<any>>;
  /**
   * Fires immediately after the component completes the update if the modal is being displayed. 
   */
  isOpen: EventEmitter<CustomEvent<any>>;
  /**
   * Fires immediately after showOverlay property changes if the modal is being displayed. 
   */
  willClose: EventEmitter<CustomEvent<any>>;
  /**
   * Fires immediately after the component completes the update if the modal isn't being displayed. 
   */
  isClosed: EventEmitter<CustomEvent<any>>;
  /**
   * Fires on backdrop click. 
   */
  backdropClicked: EventEmitter<CustomEvent<any>>;

}

@ProxyCmp({
  tagName: 'grit-wc-overlay-container',
  customElement: undefined,
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'fixScrollBar', 'name', 'parentSelector', 'pii', 'showCloseButton', 'showOverlay', 'type'],
  methods: ['openOverlay', 'closeOverlay']
})
@Component({
  selector: 'grit-wc-overlay-container',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'fixScrollBar', 'name', 'parentSelector', 'pii', 'showCloseButton', 'showOverlay', 'type']
})
export class GritWcOverlayContainer {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['willOpen', 'isOpen', 'willClose', 'isClosed', 'backdropClicked']);
  }
}

import type { GritEventData as IGritDatePickerGritEventData } from '@progleasing/grit-universal';
import type { GritPickerEventData as IGritDatePickerGritPickerEventData } from '@progleasing/grit-universal';
export declare interface GritWcPicker extends Components.GritWcPicker {
  /**
   * Event fired whenever a value is picked in the select,
returning the current selected value. 
   */
  pickerValue: EventEmitter<CustomEvent<GritEventData<IGritDatePickerGritPickerEventData>>>;

}

@ProxyCmp({
  tagName: 'grit-wc-picker',
  customElement: undefined,
  inputs: ['data', 'isOpen', 'selectableData', 'value']
})
@Component({
  selector: 'grit-wc-picker',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['data', 'isOpen', 'selectableData', 'value']
})
export class GritWcPicker {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['pickerValue']);
  }
}


export declare interface GritWcProgLogo extends Components.GritWcProgLogo {}

@ProxyCmp({
  tagName: 'grit-wc-prog-logo',
  customElement: undefined,
  inputs: ['logoHeight', 'logoType', 'logoWidth']
})
@Component({
  selector: 'grit-wc-prog-logo',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['logoHeight', 'logoType', 'logoWidth']
})
export class GritWcProgLogo {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface GritWcQrCode extends Components.GritWcQrCode {}

@ProxyCmp({
  tagName: 'grit-wc-qr-code',
  customElement: undefined,
  inputs: ['size', 'tutorial', 'url']
})
@Component({
  selector: 'grit-wc-qr-code',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['size', 'tutorial', 'url']
})
export class GritWcQrCode {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}

import type { GritEventData as IGritRadioGritEventData } from '@progleasing/grit-universal';
import type { GritRadioEventData as IGritRadioGritRadioEventData } from '@progleasing/grit-universal';
export declare interface GritWcRadio extends Components.GritWcRadio {
  /**
   * Event that is passed to radio-group, and radio-group surfaces to the consumer of the component. 
   */
  gritUpdate: EventEmitter<CustomEvent<GritEventData<IGritRadioGritRadioEventData>>>;

}

@ProxyCmp({
  tagName: 'grit-wc-radio',
  customElement: undefined,
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'checked', 'disabled', 'error', 'fontFamily', 'fontWeight', 'name', 'pii', 'radioNativeElementRef', 'value']
})
@Component({
  selector: 'grit-wc-radio',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'checked', 'disabled', 'error', 'fontFamily', 'fontWeight', 'name', 'pii', 'radioNativeElementRef', 'value']
})
export class GritWcRadio {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['gritUpdate']);
  }
}

import type { GritEventData as IGritRadioGroupGritEventData } from '@progleasing/grit-universal';
import type { GritRadioEventData as IGritRadioGroupGritRadioEventData } from '@progleasing/grit-universal';
export declare interface GritWcRadioGroup extends Components.GritWcRadioGroup {
  /**
   * Event bubbling from radio input to handle the change in a radio btn.
Can be consumed with `onChange={(event) => }` in the grit-wc-radio-group html element
The event returns @returns event: "grit-update"
value: {
checked: boolean
name: string
value: string
}
}
   */
  gritUpdate: EventEmitter<CustomEvent<GritEventData<IGritRadioGroupGritRadioEventData>>>;

}

@ProxyCmp({
  tagName: 'grit-wc-radio-group',
  customElement: undefined,
  inputs: ['disabled', 'value']
})
@Component({
  selector: 'grit-wc-radio-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['disabled', 'value']
})
export class GritWcRadioGroup {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['gritUpdate']);
  }
}


export declare interface GritWcSkeletonItem extends Components.GritWcSkeletonItem {}

@ProxyCmp({
  tagName: 'grit-wc-skeleton-item',
  customElement: undefined,
  inputs: ['borderRadius', 'height', 'isAnimated', 'minHeight', 'minWidth', 'type', 'width']
})
@Component({
  selector: 'grit-wc-skeleton-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['borderRadius', 'height', 'isAnimated', 'minHeight', 'minWidth', 'type', 'width']
})
export class GritWcSkeletonItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface GritWcSkiplink extends Components.GritWcSkiplink {}

@ProxyCmp({
  tagName: 'grit-wc-skiplink',
  customElement: undefined,
  inputs: ['analyticsCustomObj', 'analyticsEnabled']
})
@Component({
  selector: 'grit-wc-skiplink',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['analyticsCustomObj', 'analyticsEnabled']
})
export class GritWcSkiplink {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface GritWcSlider extends Components.GritWcSlider {
  /**
   * Event fired each time a change in the value
of the slider happens, returning the current value. 
   */
  update: EventEmitter<CustomEvent<number>>;

}

@ProxyCmp({
  tagName: 'grit-wc-slider',
  customElement: undefined,
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'label', 'max', 'min', 'step', 'value']
})
@Component({
  selector: 'grit-wc-slider',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'label', 'max', 'min', 'step', 'value']
})
export class GritWcSlider {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['update']);
  }
}


export declare interface GritWcSpinner extends Components.GritWcSpinner {}

@ProxyCmp({
  tagName: 'grit-wc-spinner',
  customElement: undefined,
  inputs: ['color', 'size', 'strokeWidth']
})
@Component({
  selector: 'grit-wc-spinner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['color', 'size', 'strokeWidth']
})
export class GritWcSpinner {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface GritWcStep extends Components.GritWcStep {}

@ProxyCmp({
  tagName: 'grit-wc-step',
  customElement: undefined,
  inputs: ['stage']
})
@Component({
  selector: 'grit-wc-step',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['stage']
})
export class GritWcStep {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface GritWcStepper extends Components.GritWcStepper {}

@ProxyCmp({
  tagName: 'grit-wc-stepper',
  customElement: undefined
})
@Component({
  selector: 'grit-wc-stepper',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>'
})
export class GritWcStepper {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface GritWcSwitch extends Components.GritWcSwitch {
  /**
   * Event that fires when the switch changes state returning
the current state. 
   */
  toggled: EventEmitter<CustomEvent<any>>;

}

@ProxyCmp({
  tagName: 'grit-wc-switch',
  customElement: undefined,
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'checked', 'disabled', 'labelOff', 'labelOn', 'labelPosition', 'labels', 'name', 'pii', 'showLabels']
})
@Component({
  selector: 'grit-wc-switch',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'checked', 'disabled', 'labelOff', 'labelOn', 'labelPosition', 'labels', 'name', 'pii', 'showLabels']
})
export class GritWcSwitch {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['toggled']);
  }
}


export declare interface GritWcTopNavBar extends Components.GritWcTopNavBar {
  /**
   *  
   */
  gritLeftIconClicked: EventEmitter<CustomEvent<MouseEvent>>;
  /**
   *  
   */
  gritRightIconClicked: EventEmitter<CustomEvent<MouseEvent>>;

}

@ProxyCmp({
  tagName: 'grit-wc-top-nav-bar',
  customElement: undefined,
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'fixed', 'hideLeftIcon', 'hideRightIcon', 'imgSrc', 'leftIconName', 'removeSpacer', 'rightIconName']
})
@Component({
  selector: 'grit-wc-top-nav-bar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['analyticsCustomObj', 'analyticsEnabled', 'fixed', 'hideLeftIcon', 'hideRightIcon', 'imgSrc', 'leftIconName', 'removeSpacer', 'rightIconName']
})
export class GritWcTopNavBar {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['gritLeftIconClicked', 'gritRightIconClicked']);
  }
}


export declare interface GritWcValidationMessageItem extends Components.GritWcValidationMessageItem {}

@ProxyCmp({
  tagName: 'grit-wc-validation-message-item',
  customElement: undefined,
  inputs: ['errorKey', 'inputBlur', 'inputValue']
})
@Component({
  selector: 'grit-wc-validation-message-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['errorKey', 'inputBlur', 'inputValue']
})
export class GritWcValidationMessageItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface GritWcValidationMessageList extends Components.GritWcValidationMessageList {}

@ProxyCmp({
  tagName: 'grit-wc-validation-message-list',
  customElement: undefined,
  inputs: ['inputBlur', 'inputValue']
})
@Component({
  selector: 'grit-wc-validation-message-list',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['inputBlur', 'inputValue']
})
export class GritWcValidationMessageList {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface IconButtonDemo extends Components.IconButtonDemo {}

@ProxyCmp({
  tagName: 'icon-button-demo',
  customElement: undefined
})
@Component({
  selector: 'icon-button-demo',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>'
})
export class IconButtonDemo {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}
